module.exports = __webpack_public_path__ + "img/baseline-print_disabled-24px.65aada76.svg";